import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classnames from 'classnames';

export default class FilterWithMapper extends Component {
    static propTypes = {
        className: PropTypes.string,
        disabled: PropTypes.bool,
        filter: PropTypes.any,
        onChange: PropTypes.func,
        mapper: PropTypes.any.isRequired,
        shouldHaveAllOption: PropTypes.bool
    };

    static hr = [ 'hr' ];

    static defaultProps = {
        shouldHaveAllOption: true
    };

    constructor(props) {
        super(props);

        this.buildOptions = this.buildOptions.bind(this);
    }

    buildOptions() {
        const options = [];

        if (this.props.shouldHaveAllOption) {
            options.push(<option key="" value=""></option>);
        }

        _.forEach(this.props.mapper, (value, key) => {
            if (_.isArray(value)) {
                if (_.isEqual(FilterWithMapper.hr, value)) {
                    options.push(<option key={value[0] + key} disabled>──────────</option>);
                } else {
                    options.push(<option key={value[2] || value[0]} value={value[0]}>{value[1]?.toUpperCase()}</option>);
                }
            } else {
                options.push(<option key={key} value={key}>{_.toUpper(value)}</option>);
            }
        });

        return options;
    }
    render() {
        return (
            <select
                className={classnames('filter-input', this.props.className)}
                disabled={this.props.disabled}
                onChange={(event) => this.props.onChange(event.target.value)}
                value={_.get(this.props, 'filter.value', '')}
            >
                {this.buildOptions()}
            </select>
        );
    }
}
